var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',_vm._b({model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},'v-snackbar',_vm.options,false),[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }